import React from 'react';
import OpsiApp from './OpsiApp';
import Footer from '../Footer/Footer';

const AppMobile = (props) => {

  return (
    <div className="text-center">
      <OpsiApp />
      <Footer></Footer>
    </div>
  )
};

export default AppMobile;
